<template>
  <div v-if="isShown" class="mb-1.5">
    <div
      class="bg-neutral-100 dark:bg-slate-800 border border-gray-200 dark:border-slate-600 rounded-[12px] py-1.5 ltr:pl-3 ltr:pr-2 rtl:pr-3 rtl:pl-2 flex items-center gap-2 overflow-hidden cursor-pointer"
      @click="onReplyContentClick(data.content_attributes.in_reply_to)"
    >
      <div class="self-stretch w-0.5 bg-green-300 flex-shrink-0" />
      <div class="flex-grow min-w-0 flex flex-col gap-0.5">
        <span class="text-xs font-semibold text-green-700 truncate">
          {{ replyName }}
        </span>
        <div
          v-dompurify-html="replyText"
          dir="auto"
          class="reply-preview text-xs text-gray-500 dark:text-slate-400 line-clamp-1"
        />
      </div>
      <div v-if="replyThumb" class="flex-shrink-0">
        <div class="w-[58px] h-[42px] relative overflow-hidden rounded">
          <div
            v-if="replyThumb.url"
            class="absolute inset-0 bg-cover bg-center"
            :style="{ backgroundImage: 'url(' + replyThumb.url + ')' }"
          />
          <div
            v-else
            class="w-full h-full flex items-center justify-center opacity-50"
          >
            <fluent-icon :icon="replyThumb.icon" size="24" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MESSAGE_TYPE } from 'shared/constants/messages';
import messageFormatterMixin from 'shared/mixins/messageFormatterMixin';

export default {
  name: 'Reply',
  mixins: [messageFormatterMixin],
  props: {
    replyData: {},
    data: {},
    isFromBot: false,
  },
  computed: {
    isShown() {
      return !!this.replyData;
    },
    replyName() {
      return this.replyData.sender?.name;
    },
    replyText() {
      return this.formatMessage(this.replyData.content, false, false, false);
    },
    replyThumb() {
      let res;
      if (this.replyData.file_type) {
        res = { url: this.replyData.thumb_url };
        if (!res.url) {
          switch (this.replyData.file_type) {
            case 'video':
              res.icon = 'video';
              break;
            case 'audio':
              res.icon = 'microphone';
              break;
            default:
              res.icon = 'document';
          }
        }
      }

      return res;
    },
    mediaClass() {
      return this.replyData.file_type && 'content-' + this.replyData.file_type;
    },
    isIncoming() {
      return this.data?.message_type === MESSAGE_TYPE.INCOMING;
    },
    isTemplate() {
      return (
        this.data?.message_type === MESSAGE_TYPE.TEMPLATE || this.isFromBot
      );
    },
    contentAttributes() {
      return this.data.content_attributes || {};
    },
  },
  methods: {
    onReplyContentClick(messageId) {
      bus.$emit('setActiveChatOnMessage', messageId);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .reply-preview {
    p {
      margin: 0;
      display: inline;
    }
    a {
      color: inherit;
      text-decoration: none;
    }
    br {
      display: none;
    }
  }
}
</style>
